export const subscriptionsKeys = {
    subscription: (subdomain) => ['community:plan', subdomain],
    pricingTable: (subdomain) => ['community:pricing-table', subdomain],
    subscriptionStatus: (subdomain) => ['community:subscription:status', subdomain],
    listPromotionBooking: (subdomain) => ['promotion', subdomain],
    currentBoost: (subdomain) => ['community:boost:current', subdomain],
    activeBoosts: (subdomain) => ['community:boost:active', subdomain],
};
